export const ADD_FLOOR_ERROR = 'ADD_FLOOR_ERROR';
export const ADD_FLOOR_LOADING = 'ADD_FLOOR_LOADING';
export const ADD_FLOOR_SUCCESS = 'ADD_FLOOR_SUCCESS';

export const UPDATE_FLOOR_ERROR = 'UPDATE_FLOOR_ERROR';
export const UPDATE_FLOOR_LOADING = 'UPDATE_FLOOR_LOADING';
export const UPDATE_FLOOR_SUCCESS = 'UPDATE_FLOOR_SUCCESS';

export const FETCH_FLOOR_ERROR = 'FETCH_FLOOR_ERROR';
export const FETCH_FLOOR_LOADING = 'FETCH_FLOOR_LOADING';
export const FETCH_FLOOR_SUCCESS = 'FETCH_FLOOR_SUCCESS';

export const FETCH_BY_ID_FLOOR_ERROR = 'FETCH_BY_ID_FLOOR_ERROR';
export const FETCH_BY_ID_FLOOR_LOADING = 'FETCH_BY_ID_FLOOR_LOADING';
export const FETCH_BY_ID_FLOOR_SUCCESS = 'FETCH_BY_ID_FLOOR_SUCCESS';

export const DELETE_FLOOR_ERROR = 'DELETE_FLOOR_ERROR';
export const DELETE_FLOOR_LOADING = 'DELETE_FLOOR_LOADING';
export const DELETE_FLOOR_SUCCESS = 'DELETE_FLOOR_SUCCESS';

export const DELETE_FLOOR_FAILURE = 'DELETE_FLOOR_FAILURE';
export const FETCH_FLOOR_FAILURE = 'FETCH_FLOOR_FAILURE';
export const UPDATE_FLOOR_FAILURE = 'UPDATE_FLOOR_FAILURE';

export const FETCH_BUILDING_ERROR = 'FETCH_BUILDING_ERROR';
export const FETCH_BUILDING_LOADING = 'FETCH_BUILDING_LOADING';
export const FETCH_BUILDING_SUCCESS = 'FETCH_BUILDING_SUCCESS';

export const FETCH_BUILDING_BY_ID_LOADING = 'FETCH_BUILDING_BY_ID_LOADING';
export const FETCH_BUILDING_BY_ID_SUCCESS = 'FETCH_BUILDING_BY_ID_SUCCESS';
export const FETCH_BUILDING_BY_ID_ERROR = 'FETCH_BUILDING_BY_ID_ERROR';

export const UPDATE_BUILDING_LOADING = 'UPDATE_BUILDING_LOADING';
export const UPDATE_BUILDING_SUCCESS = 'UPDATE_BUILDING_SUCCESS';
export const UPDATE_BUILDING_ERROR = 'UPDATE_BUILDING_ERROR';
